module.exports = __webpack_public_path__ + "assets/img/a62b7a038e56be8880818c6d3e6d8654.png";